import {
  FormLabel,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CustomValueSelect from "../../../components/Common/CustomInput/CustomValueSelect";
import Card from "../../../components/card/Card";
import { selectGroupPackage } from "../group/redux/selector";
import { selectFormData } from "./redux/selector";
import { actions } from "./redux/slice";
import CustomInput from "../../../components/Common/CustomInput";

const Items = () => {
  const { t } = useTranslation();
  const textColor = useColorModeValue("navy.700", "white");
  const dispatch = useDispatch();
  const groupList = useSelector(selectGroupPackage);
  const form = useSelector(selectFormData);

  const handleFieldChange = ({
    name,
    value,
    groupId,
  }: {
    name: string;
    value: any;
    groupId: string;
  }) => {
    dispatch(actions.updateItemsFormValue({ name, value, groupId }));
  };
  useEffect(() => {
    console.log(form?.items, "form?.items");

    return () => {};
  }, [form?.items]);

  const getProductIdValue = (groupID: string) => {
    return (
      form?.items.find((item) => item?.groupId === groupID)?.productId || ""
    );
  };

  const getSortOrderValue = (groupID: string) => {
    return (
      form?.items.find((item) => item?.groupId === groupID)?.sortOrder?.toString() || "0"
    );
  };

  return (
    <Card my="20px" p="20px" flexDirection="column">
      <FormLabel
        display="flex"
        ms="4px"
        fontSize="lg"
        fontWeight="500"
        color={textColor}
        mb="8px"
      >
        {t("package.form.items")}
      </FormLabel>

      <Card>
        <Table variant="simple" maxWidth="50%">
          <Thead bg="gray.100">
            <Tr>
              <Th width="100px">{t("common.list.sNo")}</Th>
              <Th>{t("package.form.group")}</Th>
              <Th>{t("package.form.product")}</Th>
              <Th>{t("package.form.sortOrder")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {groupList?.map((row, index) => {
              return (
                <Tr key={index} _hover={{ bg: "gray.50" }}>
                  <Td>
                    <Text fontWeight="semibold">{index + 1}</Text>
                  </Td>
                  <Td pr={3}>
                    <Text fontSize="sm" color="gray.500">
                      {row?.title}
                    </Text>
                  </Td>
                  <Td pr={3}>
                    <Text fontSize="sm" color="gray.500">
                      <CustomValueSelect
                        name={"productId"}
                        value={getProductIdValue(row._id)}
                        handleChange={({ id }) =>
                          handleFieldChange({
                            name: "productId",
                            value: id,
                            groupId: row._id,
                          })
                        }
                        title={t("package.form.selectProduct")}
                        data={row?.groupProducts}
                        isFromApi
                      />
                    </Text>
                  </Td>
                  <Td pr={3}>
                    <CustomInput
                      name={"sortOrder"}
                      value={getSortOrderValue(row._id)}
                      handleChange={(evt:any)=>handleFieldChange({
                            name: "sortOrder",
                            value: evt.target.value,
                            groupId: row._id,
                          })}
                      placeholder={`${t("package.form.enterSortOrder")}`}
                      title={`${t("package.form.sortOrder")}`}
                      type="number"
                    />
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Card>
    </Card>
  );
};

export default Items;
